export default __webpack_public_path__ + "media/images/logo/media/sotokoto-1e2f7f8d594eea8cae779f989589b3c6.png";